import React from 'react'
import {Progress} from 'reactstrap'

const GenerateBackgroundLoading = ({
    text = 'Generating your background, please wait...',
    percentage = 0,
    size = 64,
}) => {
    return (
        <div className="LoadingContainer text-center">
            <div className="Percentage mt-3 d-flex flex-column align-items-center">
                <div
                    className="CircularProgress"
                    style={{
                        "--value": percentage,
                        "--size": `${size}px`,
                    }}
                >
                    <div className="CircularProgressValueContainer"><span className="CircularProgressValue">{percentage}%</span></div>
                </div>
                {/* Keep native Progress for a11y and potential fallbacks */}
                <Progress value={percentage} className="visually-hidden" />
            </div>
            <div className="LoadingText">{text}</div>
        </div>
    )
}

export default GenerateBackgroundLoading

